"use strict";

exports.__esModule = true;
var _TimelineOption = _interopRequireDefault(require("./TimelineOption"));
exports.default = _TimelineOption.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}